import BaseRepository from '@/baseRepository/BaseRepository';
const categoriesResource = '/api/v1/categories';
const productResource = `/api/v1/products`;
const supplierProductResource = `/api/v1/supplierproducts`;

export default {
  categoreisTreeList(
    baseURL = {},
    headers = {},
    params = {},
    paramsSerializer = {}
  ) {
    return BaseRepository.get(`${categoriesResource}`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  selectProductForAddingNewSupplierProduct(
    categoryId,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.get(
      `${categoriesResource}/${categoryId}/supplierproducts/properties`,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getProductAllProperties(categoryId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(
      `${categoriesResource}/${categoryId}/properties/by-supplier`,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getProducts(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${productResource}`, {
      baseURL,
      headers,
      params,
    });
  },
  getProductById(productId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${productResource}/active/${productId}`, {
      baseURL,
      headers,
      params,
    });
  },
  getProductTitleSuggestion(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${productResource}/product-title-suggestion`, {
      baseURL,
      headers,
      params,
    });
  },
  getSupplierProducts(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierProductResource}`, {
      baseURL,
      headers,
      params,
    });
  },
   getSupplierSaleProducts(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierProductResource}/search`, {
      baseURL,
      headers,
      params,
    });
  },
  getSupplierProductById(
    supplierProductId,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.get(
      `${supplierProductResource}/${supplierProductId}`,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  createSupplierProduct(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${supplierProductResource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  createSupplierProductWithProduct(
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.post(
      `${supplierProductResource}/with-product`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  editSupplierProduct(
    supplierProductId,
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.put(
      `${supplierProductResource}/${supplierProductId}`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  filterSupplierProduct(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierProductResource}/filter`, {
      baseURL,
      headers,
      params,
    });
  },
  getSupplierProductByIdList(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierProductResource}/byidlist`, {
      baseURL,
      headers,
      params,
    });
  },
  getSupplierProductCategoryTypes(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${supplierProductResource}/category-types`, {
      baseURL,
      headers,
      params,
    });
  },
  getSupplierProductProductType(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierProductResource}/product-types`, {
      baseURL,
      headers,
      params,
    });
  },
  postRequestConfirm(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${supplierProductResource}/${id}/request-confirm`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  postArchive(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${supplierProductResource}/${id}/archive`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getSupplierProductEvents(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierProductResource}/${id}/events`, {
      baseURL,
      headers,
      params,
    });
  },

  getSupplierProductsByProductId(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierProductResource}/byproduct`, {
      baseURL,
      headers,
      params,
    });
  },
  registerSupplierProductPrice(
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.post(
      `${supplierProductResource}/addprice/bysupplier`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getSupplierProductPrice(suplierProductId,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.get(
      `${supplierProductResource}/${suplierProductId}/get-price`,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getCategoryData(categoryId,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.get(
      `${categoriesResource}/${categoryId}/bysupplier`,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  ///api/v1/categories/{id}/bysupplier
};
 